import * as React from "react";

function SvgCurve2Inverted(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path d="M-10 207.4h1620S1608.1.1 1604.2 3.7c-32.8 30.8-203.9 178.2-465.9 178.2C884 181.9 234.9 65.6-10 7.8v199.6z" /></svg>;
}

export default SvgCurve2Inverted;